import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-content-dialog',
  templateUrl: './content-dialog.component.html',
  styleUrls: ['./content-dialog.component.sass']
})
export class ContentDialogComponent implements OnInit {

  form: FormGroup;
  currentValueEvaluationAllied: number | string;
  evaluationAllied: number | string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    const { currentValueEvaluationAllied, evaluationAllied } = this.data;

    this.currentValueEvaluationAllied = currentValueEvaluationAllied;
    this.evaluationAllied = +evaluationAllied.replace(/\./g, '').replace(',', '.');

    this.form = this.fb.group({
      currentValueEvaluationAllied: [this.currentValueEvaluationAllied, []],
      evaluationAllied: [this.evaluationAllied, []],
    });
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }
}
